import { useMemo } from 'react';

import { useAuthHeaders } from '@pletly/feature-auth';
import { useFetchMedia } from '@pletly/ui';

export const useProfilePicture = (photoUrl?: string) => {
	const { getHeaders } = useAuthHeaders();
	const headers = useMemo(
		() => (photoUrl ? getHeaders(photoUrl) : undefined),
		[getHeaders, photoUrl],
	);
	const source = useMemo(() => ({ uri: photoUrl, headers }), [headers, photoUrl]);
	const url = useFetchMedia(source);

	return useMemo(() => {
		if (!url) return null;

		const imgElement = new Image();
		imgElement.src = url;
		imgElement.crossOrigin = 'anonymous';

		return imgElement;
	}, [url]);
};
